<template>
  <div>
    <section
      v-if="isMobile"
      class="bg-cover bg-center relative"
      style="background-image: url('/images/darkSections/fondoMobile.jpg')"
    >
      <div class="md:px-10">
        <section-buttons-show />
      </div>
    </section>
    <section
      v-else
      class="bg-cover bg-center relative"
      style="background-image: url('/images/darkSections/fondo.jpg')"
    >
      <div class="md:px-10">
        <section-buttons-show />
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import SectionButtonsShow from '@/components/SectionButtonsShow.vue';

defineProps({
  title: String,
  titleSecondLine: String,
  titleThirdLine: String,
  description: String,
  imageSrc: String
});

const isMobile = ref(window.innerWidth <= 767);

window.addEventListener('resize', () => {
  isMobile.value = window.innerWidth <= 767;
});
</script>
